import {
  ResourceType,
  Action,
  Anonymous,
  CoworkingMember,
  HQEmployee,
  OperationalManager,
  Role,
} from "@industriousoffice/member-portal-rbac";
import { LegacyUser, LegacyUserGroupingDto } from "@/api/user/legacyUserTypes";

const getRole = (user: LegacyUser): Role => {
  switch (user.role) {
    case "Coworking Member":
      return new CoworkingMember(user as any);
    case "HQ Employee":
      return new HQEmployee(user as any);
    case "Operational Manager":
      return new OperationalManager(user as any);
    default:
      return new Anonymous(user as any);
  }
};

export const isDecisionMaker = (user: LegacyUser): boolean => {
  const role = getRole(user);
  return role.isDecisionMaker;
};

export const isVirtualMember = (user: LegacyUser): boolean => {
  const role = getRole(user);
  return role.isVirtualMember;
};

export const isManager = (user: LegacyUser) => {
  const role = getRole(user);
  return role.isManager;
};

export const isAllowed = ({
  user,
  action,
  resourceType,
  obj,
}: {
  user: LegacyUser;
  action: Action;
  resourceType: ResourceType;
  obj: any;
}) => {
  const role = getRole(user);
  return role.can({
    action,
    resourceType,
    obj,
  });
};

export const RBAC = (option: any) => (extraOption: any) =>
  isAllowed({ ...option, ...extraOption });

export const groupingFeatureRoleAccess = {
  hasFeature: RBAC({
    resourceType: ResourceType.GroupingFeatureToggle,
    action: Action.HasFeature,
  }),
};

export const canAccessFeatureToggle = (
  user: LegacyUser,
  userGroupings: LegacyUserGroupingDto[],
  featureKey: string
) =>
  groupingFeatureRoleAccess.hasFeature({
    obj: {
      groupings: userGroupings,
      groupingFeatureKey: featureKey,
    },
    user,
  });

export const canAccessHotDeskFeature = (
  user: LegacyUser,
  userGroupings: LegacyUserGroupingDto[]
) => {
  if (isVirtualMember(user)) {
    return false;
  }
  return (
    isManager(user) || canAccessFeatureToggle(user, userGroupings, "HotDesk")
  );
};
